"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionTriggerType = void 0;
var JourneyActionTriggerType;
(function (JourneyActionTriggerType) {
    JourneyActionTriggerType["ConversationUpdated"] = "ConversationUpdated";
    JourneyActionTriggerType["ConversationCreated"] = "ConversationCreated";
    JourneyActionTriggerType["ContactCreated"] = "ContactCreated";
    JourneyActionTriggerType["ContactUpdated"] = "ContactUpdated";
    JourneyActionTriggerType["NewInboundMailMessage"] = "NewInboundMailMessage";
    JourneyActionTriggerType["NewOutboundMailMessage"] = "NewOutboundMailMessage";
    JourneyActionTriggerType["NewInboundVoiceCall"] = "NewInboundVoiceCall";
    JourneyActionTriggerType["NewOutboundVoiceCall"] = "NewOutboundVoiceCall";
    JourneyActionTriggerType["NewInternalVoiceCall"] = "NewInternalVoiceCall";
    JourneyActionTriggerType["NewInboundVoiceCallBridge"] = "NewInboundVoiceCallBridge";
    JourneyActionTriggerType["NewOutboundVoiceCallBridge"] = "NewOutboundVoiceCallBridge";
    JourneyActionTriggerType["NewInternalVoiceCallBridge"] = "NewInternalVoiceCallBridge";
    JourneyActionTriggerType["InboundVoiceCallHangedUp"] = "InboundVoiceCallHangedUp";
    JourneyActionTriggerType["OutboundVoiceCallHangedUp"] = "OutboundVoiceCallHangedUp";
    JourneyActionTriggerType["InternalVoiceCallHangedUp"] = "InternalVoiceCallHangedUp";
    JourneyActionTriggerType["InboundVoiceCallBridgeLeave"] = "InboundVoiceCallBridgeLeave";
    JourneyActionTriggerType["OutboundVoiceCallBridgeLeave"] = "OutboundVoiceCallBridgeLeave";
    JourneyActionTriggerType["InternalVoiceCallBridgeLeave"] = "InternalVoiceCallBridgeLeave";
    JourneyActionTriggerType["InboundVoiceCallAnswered"] = "InboundVoiceCallAnswered";
    JourneyActionTriggerType["OutboundVoiceCallAnswered"] = "OutboundVoiceCallAnswered";
    JourneyActionTriggerType["InternalVoiceCallAnswered"] = "InternalVoiceCallAnswered";
    JourneyActionTriggerType["InboundVoiceCallBridgeAnswered"] = "InboundVoiceCallBridgeAnswered";
    JourneyActionTriggerType["OutboundVoiceCallBridgeAnswered"] = "OutboundVoiceCallBridgeAnswered";
    JourneyActionTriggerType["InternalVoiceCallBridgeAnswered"] = "InternalVoiceCallBridgeAnswered";
    JourneyActionTriggerType["NewDraft"] = "NewDraft";
    JourneyActionTriggerType["NewInternalNote"] = "NewInternalNote";
    JourneyActionTriggerType["SinceConversation"] = "SinceConversation";
})(JourneyActionTriggerType = exports.JourneyActionTriggerType || (exports.JourneyActionTriggerType = {}));
